import { render, staticRenderFns } from "./plainteWithPeriod.vue?vue&type=template&id=b20852ce&"
import script from "./plainteWithPeriod.vue?vue&type=script&lang=js&"
export * from "./plainteWithPeriod.vue?vue&type=script&lang=js&"
import style0 from "./plainteWithPeriod.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports